// extracted by mini-css-extract-plugin
export default {"container":"USP_container__i7P0e","image":"USP_image__i34Rb","left":"USP_left__cAucv","text":"USP_text__lKXIR","btn":"USP_btn__zJBg8"};